import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";

const { NODE_ENV } = process.env;

const isProd = NODE_ENV === "production";

const config = {
  apiKey: "AIzaSyC3X-gpk4FzEhflVfxXu8ukRffO74SYzYs",
  authDomain: "diario24horas-7163e.firebaseapp.com",
  databaseURL: `https://diario24horas-${ isProd ? '7163e' : 'hlg'}.firebaseio.com`,
  projectId: "diario24horas-7163e",
  storageBucket: "diario24horas-7163e.appspot.com",
  messagingSenderId: "678404927729",
  appId: "1:678404927729:web:4754ba2ae80b7b43f63950",
};

export const firebaseImpl = firebase.initializeApp(config);
export const firebaseDatabase = firebase.database();
export const firebaseStorage = firebase.storage();
export const firebaseAuth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
